<template align="center">
  <div class="animated fadeIn fadeOut text-center">
    <!-- is -->
    <b-row>
      <b-col>
        <b-card class="animated fadeIn fadeOut">
          <!-- 파트너 -->
          <h4>Partner</h4>
            <b-progress class="mt-2" :max="model.partner.total" show-value>
              <b-progress-bar :value="model.partner.enable" variant="success"></b-progress-bar>
              <b-progress-bar :value="model.partner.disable" variant="dark"></b-progress-bar>
            </b-progress>
        </b-card>
      </b-col>
      <b-col>
        <b-card class="animated fadeIn fadeOut">
          <h4>Group</h4>
            <b-progress class="mt-2" :max="model.group.total" show-value>
              <b-progress-bar :value="model.group.enable" variant="success"></b-progress-bar>
              <b-progress-bar :value="model.group.disable" variant="dark"></b-progress-bar>
            </b-progress>
        </b-card>
      </b-col>
      <b-col>
        <b-card class="animated fadeIn fadeOut">
          <h4>User</h4>
            <b-progress class="mt-2" :max="model.user.total" show-value>
              <b-progress-bar :value="model.user.enable" variant="success"></b-progress-bar>
              <b-progress-bar :value="model.user.disable" variant="dark"></b-progress-bar>
            </b-progress>
        </b-card>
      </b-col>
      <b-col>
        <b-card class="animated fadeIn fadeOut">
          <h4>Service</h4>
            <b-progress class="mt-2" :max="model.subscription.total" show-value>
              <b-progress-bar v-for="(item, index) in model.subscription.list" :value="item.total" v-bind:key="index" :variant="codes.COLORS[index]"></b-progress-bar>
            </b-progress>
        </b-card>
      </b-col>
    </b-row>
    <vcl-facebook v-if="loading_1"></vcl-facebook>
    <b-row v-else>
      <b-col>
        <b-card class="animated fadeIn fadeOut">
          <span class="float-right">Latest 7 day</span>
          <line-chart :data="model.login" :messages="{ empty: 'no have data' }" label="Daily User Login" :legend="true"></line-chart>
        </b-card>
      </b-col>
    </b-row>
    <vcl-facebook v-if="loading_2"></vcl-facebook>
    <b-row v-else>
      <b-col md="3">
        <b-card class="animated fadeIn fadeOut">
          <h5>WMDS</h5>
          <hr>
          <h3>{{model.wmds.summary.total}}</h3>
          <hr>
          <pie-chart label="Value" class="animated fadeIn fadeOut" :donut="true" :data="[['Enable',model.wmds.summary.enable],['Disable',model.wmds.summary.disable]]" :colors="['#05E07D', '#F4F801']"></pie-chart>
        </b-card>
      </b-col>
      <b-col  md="3">
        <b-card class="animated fadeIn fadeOut">
          <h5>WEBCastle</h5>
          <hr>
          <h3>{{model.webcastle.summary.total}}</h3>
          <hr>
          <pie-chart label="Value" class="animated fadeIn fadeOut" :donut="true" :data="[['Enable',model.webcastle.summary.enable],['Disable',model.webcastle.summary.disable]]" :colors="['#05E07D', '#F4F801']"></pie-chart>
        </b-card>
      </b-col>
      <b-col  md="3">
        <b-card class="animated fadeIn fadeOut">
          <h5>WSFinder</h5>
          <hr>
          <h3>{{model.wsfinder.summary.total}}</h3>
          <hr>
          <pie-chart label="Value" class="animated fadeIn fadeOut" :donut="true" :data="[['Enable',model.wsfinder.summary.enable],['Disable',model.wsfinder.summary.disable]]" :colors="['#05E07D', '#F4F801']"></pie-chart>
        </b-card>
      </b-col>
      <b-col  md="3">
        <b-card class="animated fadeIn fadeOut">
          <h5>WFDetector</h5>
          <hr>
          <h3>{{model.forgery.summary.total}}</h3>
          <hr>
          <pie-chart label="Value" class="animated fadeIn fadeOut" :donut="true" :data="[['WSFinder',model.forgery.summary.wsfinder],['WMDS',model.forgery.summary.wmds]]" :colors="['#05E07D', '#F4F801']"></pie-chart>
        </b-card>
      </b-col>
    </b-row>
    <vcl-facebook v-if="loading_3"></vcl-facebook>
    <b-row v-else>
      <b-col md="3">
        <b-card no-body class="bg-warning animated fadeIn fadeOut">
          <b-card-body class="pb-0">
            <h4><strong>Detect</strong></h4>
            <hr>
            <h1>
              <span>{{ model.wmds.detect.dt_d || 0 }}</span>
              <span style="color:red;font-size:20px"><span v-if="model.wmds.detect.gap >= 0">+</span> {{model.wmds.detect.gap}}</span>
            </h1>
          </b-card-body>
        </b-card>
        <b-card no-body class="bg-primary animated fadeIn fadeOut">
          <b-card-body class="pb-0">
            <h4><strong>Result</strong></h4>
            <hr>
            <h1>
              <span>{{ model.wmds.result.pg_d || 0 }}</span>
              <span style="color:red;font-size:20px"> <span v-if="model.wmds.result.gap >= 0">+</span> {{model.wmds.result.gap}}</span>
            </h1>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col  md="3">
        <b-card no-body class="bg-warning animated fadeIn fadeOut">
          <b-card-body class="pb-0">
            <h4><strong>Detect</strong></h4>
            <hr>
            <h1>
              <span>{{ model.webcastle.detect.dt_d || 0 }}</span>
              <span style="color:red;font-size:20px"><span v-if="model.webcastle.result.gap >= 0">+</span> {{model.webcastle.result.gap}}</span>
            </h1>
          </b-card-body>
        </b-card>
        <b-card no-body class="bg-danger animated fadeIn fadeOut">
          <b-card-body class="pb-0">
            <h4><strong>Block</strong></h4>
            <hr>
            <h1>
              <span>{{ model.webcastle.result.pg_d || 0 }}</span>
              <span style="color:red;font-size:20px"> <span v-if="model.webcastle.detect.gap >= 0">+</span> {{model.webcastle.detect.gap}}</span>
            </h1>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col  md="3">
        <b-card no-body class="bg-warning animated fadeIn fadeOut">
          <b-card-body class="pb-0">
            <h4><strong>Detect</strong></h4>
            <hr>
            <h1>
              <span>{{ model.wsfinder.detect.dt_d || 0 }}</span>
              <span style="color:red;font-size:20px"><span v-if="model.wsfinder.detect.gap >= 0">+</span> {{model.wsfinder.detect.gap}}</span>
            </h1>
          </b-card-body>
        </b-card>
        <b-card no-body class="bg-primary animated fadeIn fadeOut">
          <b-card-body class="pb-0">
            <h4><strong>Result</strong></h4>
            <hr>
            <h1>
              <span>{{ model.wsfinder.result.pg_d || 0 }}</span>
              <span style="color:red;font-size:20px"> <span v-if="model.wsfinder.result.gap >= 0">+</span> {{model.wsfinder.result.gap}}</span>
            </h1>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col  md="3">
        <b-card no-body class="bg-warning animated fadeIn fadeOut">
          <b-card-body class="pb-0">
            <h4><strong>WSFinder</strong></h4>
            <hr>
            <h1>
              <span>{{ model.forgery.wsfinder.pg_d || 0 }}</span>
              <span style="color:red;font-size:20px"><span v-if="model.forgery.wsfinder.gap >= 0">+</span> {{model.forgery.wsfinder.gap}}</span>
            </h1>
          </b-card-body>
        </b-card>
        <b-card no-body class="bg-warning animated fadeIn fadeOut">
          <b-card-body class="pb-0">
            <h4><strong>WMDS</strong></h4>
            <hr>
            <h1>
              <span>{{ model.forgery.wmds.pg_d || 0 }}</span>
              <span style="color:red;font-size:20px"> <span v-if="model.forgery.wmds.gap >= 0">+</span> {{model.forgery.wmds.gap}}</span>
            </h1>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <router-view ></router-view>
  </div>
</template>

<script>
import { Api, auth } from '@/service';
import vSelect from 'vue-select';
import codes from '@/codes';
import config from '../../config';
import moment from 'moment-timezone';
import { VclFacebook } from 'vue-content-loading';

export default {
  components : { vSelect, VclFacebook },
  computed: {
      f_detect() {
        return [
        { key: 'created_at', label: 'Time', sortable: false, thStyle: 'width: 10%' },
        { key: 'remote_addr', label: 'Attack', sortable: false, thStyle: 'width: 10%' },
        { key: 'target', label: 'Target', sortable: false, thStyle: 'width: 10%' },
        { key: 'is_block', label: 'Response', sortable: false, thStyle: 'width: 10%' },
        { key: 'request', label: 'Request', sortable: false },
      ]
    }
  },
  data: () => {
    return {
      loading_1 : false,
      loading_2 : false,
      loading_3 : false,
      codes,
      // new var
      chart_circle : {
        service_count : 0,
        service_data : [],
        price_count : 0,
        price_data : [],
      },
      // old var
      config,
      level_list: ['user', 'manager', 'owner', 'master'],
      month_list : [],
      year_list : [],
      option : { all : true, year : (new Date()).year, month : (new Date()).month },
      model : {
        login: [],
        login_option: [
          { title: {
              display: true,
              text: 'Custom Chart Title'
            }
          },
          { legend: {
              display: true,
              labels: { fontColor: 'rgb(255, 99, 132)' }
            }
          }
        ],
        subscription : { total : 0, list : [] },
        user : { total : 0, disable : 0, enable : 0 },
        partner : { total : 0, disable : 0, enable : 0 },
        group : { total : 0, disable : 0, enable : 0 },
        wmds : { summary : {}, result : { pg_d : 0, pg_w : 0, pg_m : 0, gap : 0 }, detect : { dt_d : 0, dt_w : 0, dt_m : 0, gap : 0 } },
        wsfinder : { summary : {}, result : { pg_d : 0, pg_w : 0, pg_m : 0, gap : 0 }, detect : { dt_d : 0, dt_w : 0, dt_m : 0, gap : 0 } },
        webcastle : { summary : {}, result : { pg_d : 0, pg_w : 0, pg_m : 0, gap : 0 }, detect : { dt_d : 0, dt_w : 0, dt_m : 0, gap : 0 } },
        forgery : { summary : {}, wsfinder : { pg_d : 0, pg_w : 0, pg_m : 0 }, wmds : { dt_d : 0, dt_w : 0, dt_m : 0 } },
      }
    }
  },
  methods: {
    NumberToStr(x) { return `${x}` },
    build_date() {
      let now = new Date
      for (let i = now.getFullYear(); i >= this.config.startYear; i--) { this.year_list.push(`${i}`) }
      for (let i = 1; i <= 12; i++) { this.month_list.push(`${i}`) }
      // load default value
      this.option  = Object.assign(this.option, { year : this.NumberToStr(now.getFullYear()), month : this.NumberToStr(now.getMonth() + 1) })
      this.model.wmds = Object.assign(this.model.wmds, this.option);
      this.model.webcastle = Object.assign(this.model.webcastle, this.option);
      this.model.wsfinder = Object.assign(this.model.wsfinder, this.option);
      this.model.forgery = Object.assign(this.model.forgery, this.option);
      this.model.forgery.wsfinder = this.model.forgery.wsfinder;
      this.model.forgery.wmds = this.model.forgery.wmds;
      // check caching

    },
    load() {
      try {

        this.loading_1 = this.loading_2 = this.loading_3 = true

        Api.Manager_Call('wmds.dashboard', 'sales', { year : this.model.wmds.year, month : this.model.wmds.month }).then(rs => {
          if(!rs.body) { return; }
          this.model.wmds.summary = rs.body.usage.data ? rs.body.usage.data : undefined;
          this.model.wmds.summary = Object.assign({}, this.model.wmds.summary, { enable : this.model.wmds.summary.total - this.model.wmds.summary.disable })
          this.model.wmds.result = rs.body.result
          this.model.wmds.detect = rs.body.detect

          this.model.wmds.result.gap = this.model.wmds.result.pg_d - this.model.wmds.result.pg_d_yesterday
          this.model.wmds.detect.gap = this.model.wmds.detect.dt_d - this.model.wmds.detect.dt_d_yesterday
        }).catch(e => { console.log('wmds', e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)});

        Api.Manager_Call('wsfinder.dashboard', 'sales', { year : this.model.wsfinder.year, month : this.model.wsfinder.month }).then(rs => {
          if(!rs.body) { return; }
          this.model.wsfinder.summary = rs.body.usage.data ? rs.body.usage.data : undefined;
          this.model.wsfinder.summary = Object.assign({}, this.model.wsfinder.summary, { enable : this.model.wsfinder.summary.total - this.model.wsfinder.summary.disable })
          this.model.wsfinder.result = rs.body.result
          this.model.wsfinder.detect = rs.body.detect

          this.model.wsfinder.result.gap = this.model.wsfinder.result.pg_d - this.model.wsfinder.result.pg_d_yesterday
          this.model.wsfinder.detect.gap = this.model.wsfinder.detect.dt_d - this.model.wsfinder.detect.dt_d_yesterday
        }).catch(e => { console.log('wsfinder', e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)});

        Api.Manager_Call('webcastle.dashboard', 'sales', { year : this.model.webcastle.year, month : this.model.webcastle.month }).then(rs => {
          if(!rs.body) { return; }
          this.model.webcastle.summary = rs.body.usage.data ? rs.body.usage.data : undefined;
          this.model.webcastle.summary = Object.assign({}, this.model.webcastle.summary, { enable : this.model.webcastle.summary.total - this.model.webcastle.summary.disable })
          this.model.webcastle.result = rs.body.result
          this.model.webcastle.detect = rs.body.detect

          this.model.webcastle.result.gap = this.model.webcastle.result.pg_d - this.model.webcastle.result.pg_d_yesterday
          this.model.webcastle.detect.gap = this.model.webcastle.detect.dt_d - this.model.webcastle.detect.dt_d_yesterday

          this.loading_2 = false // 전체 로딩 확인 후 async/await 처리해야 하나, 가장 데이터가 많은 웹캐슬 기준으로 함
        }).catch(e => { console.log('webcastle', e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)});

        Api.Manager_Call('integrity.dashboard', 'sales').then(rs => {
          if(!rs.body) { return; }
          let summary = rs.body.usage.data ? rs.body.usage.data : undefined;
          if(summary) {
            this.model.forgery.summary = {
              wsfinder : summary.wsfinder.total,
              wmds : summary.wmds.total,
              total : summary.wsfinder.total + summary.wmds.total,
              disable  : 0
            }
          }
          this.model.forgery.summary.disable = this.model.forgery.summary.total - (this.model.forgery.summary.wsfinder + this.model.forgery.summary.wmds)
          this.model.forgery.summary.enable = this.model.forgery.summary.total - this.model.forgery.summary.disable;

          this.model.forgery.wsfinder = rs.body.wsfinder;
          this.model.forgery.wmds = rs.body.wmds;

          this.model.forgery.wsfinder.gap = this.model.forgery.wsfinder.pg_d - this.model.forgery.wsfinder.dt_d_yesterday
          console.log('wsf', this.model.forgery.wsfinder.pg_d, 'wmds', this.model.forgery.wsfinder.dt_d_yesterday)
          this.model.forgery.wmds.gap = this.model.forgery.wmds.dt_d - this.model.forgery.wmds.pg_d_yesterday

        }).catch(e => { console.log('integrity', e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)});

        Api.Manager_Call('group', 'summary.sales').then(rs => {
          if(!rs.body) { return; }

          this.model = Object.assign({}, this.model, { group : rs.body })
          this.model.group.total = this.model.group.disable + this.model.group.enable
        }).catch(e => { console.log('group', e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)});

        Api.Manager_Call('partner', 'summary.sales').then(rs => {
          if(!rs.body) { return; }

          this.model = Object.assign({}, this.model, { partner : rs.body })
          this.model.partner.total = this.model.partner.disable + this.model.partner.enable
        }).catch(e => { console.log('partner', e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)});

        Api.Manager_Call('user', 'summary.sales').then(rs => {
          if(!rs.body) { return; }

          this.model = Object.assign({}, this.model, { user : rs.body })
          this.model.user.total = this.model.user.disable + this.model.user.enable
        }).catch(e => { console.log('user', e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)});

        Api.Manager_Call('subscription', 'summary.sales').then(rs => {
          if(!rs.body) { return; }
          this.model.subscription = Object.assign({}, this.model.subscription, { list : rs.body, total : _.sumBy(rs.body, x => x.total) })
          this.loading_3 = false
        }).catch(e => { console.log('subscription', e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)});


        this.loading_1 = true
        this.model.login = []
        Api.Manager({ target : 'log.login', cmd : 'dashboard.sales', body : { ts : new Date().getTime() } }).then(rs => {
          if(!rs.body || rs.body.length < 1) { return; }
          this.model.login.push({
            name : 'User Login',
            data : _.map(rs.body.user, r => [moment(r.date).format('yyyy-MM-DD'), r.cnt])
          })

          this.model.login.push({
            name : 'Partner Login',
            data : _.map(rs.body.partner, r => [moment(r.date).format('yyyy-MM-DD'), r.cnt])
          })

          if(auth.profile.permissions.toLowerCase() != 'sales') {
            this.model.login.push({
              name : 'Admin Login',
              data : _.map(rs.body.admin, r => [moment(r.date).format('yyyy-MM-DD'), r.cnt])
            })
          }


          this.loading_1 = false
        }).catch(e => { console.log('log.login', e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)});

      } catch (e) { console.log(e); this.$toastr.e("Dashboard", 'load failed') }
    },
  },
  created () {
    console.log('dashboard.vue created');
    this.build_date()
  },
  mounted () {
    console.log('dashboard.vue mounted');
    this.load()
  },
  destroyed () {
    console.log('dashboard.vue destroyed');
  },
}
</script>
